
import HeadStepItem from './components/HeadStepItem.vue';
import { steppersUtils } from '@/uikit/components/AppSteppers/utils';

export default {
  name: 'AppSteppers',
  components: { HeadStepItem },
  props: {
    startStepName: {
      type: String,
      required: true,
    },
    invalidSteps: {
      type: Object,
      default: () => {
        return {
          stepNumber: null,
          stepErrorText: 'Ошибка',
        };
      },
    },
    isShowFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      util: null,
      steps: [],
      steppersState: {
        currentStepName: this.startStepName,
        direction: 'is_next_step',
      },
    };
  },
  methods: {
    nextStep() {
      this.steppersState.direction = 'is_next_step';
      this.steppersState.currentStepName = this.util.getNextNameOfCurrentName(
        this.steppersState.currentStepName
      );
    },
    prevStep() {
      this.steppersState.direction = 'is_prev_step';
      this.steppersState.currentStepName = this.util.getPrevNameOfCurrentName(
        this.steppersState.currentStepName
      );
    },
  },
  mounted() {
    const scopedSlots = this.$scopedSlots.default();
    const children = scopedSlots.filter(
      (el: any) => el.componentOptions?.propsData
    );
    this.steps = children
      .filter((el: any) => el.componentOptions.propsData['stepName'])
      .map((el: any) => el.componentOptions.propsData['stepName']);
    this.util = steppersUtils(this.steps);
    this.steppersState.currentStepName = this.steppersState.currentStepName
      ? this.steppersState.currentStepName
      : this.steps[0];
  },
  provide() {
    return {
      steppersState: this.steppersState,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppSteppers/AppSteppers.vue